import { stylesheet } from 'typestyle';
import * as csx from 'csstips';

import { regularGrayText, linkBlueText } from '@src/styles/general';

export default stylesheet({
  container: {
    ...csx.horizontal,
    ...csx.betweenJustified,

    margin: '0 25px',
    padding: '25px 0 0 0',

    '@media (max-width: 750px)': {
      display: 'block'
    }
  },
  left: {
    flexBasis: '33%',
    marginRight: 20,

    '@media (max-width: 909px)': {
      flexBasis: '50%'
    },

    '@media (max-width: 750px)': {
      width: '100%',
      marginRight: 0
    }
  },
  right: {
    flexBasis: 'calc(67% - 20px)',

    '@media (max-width: 909px)': {
      flexBasis: '50%'
    },

    '@media (max-width: 750px)': {
      marginTop: 40,
      width: '100%'
    }
  },
  list: { listStyle: 'none', margin: 0, padding: 0, width: '100%' },
  inlineList: {
    $nest: {
      '& > *': {
        display: 'inline-block'
      }
    }
  },
  item: {
    position: 'relative',
    color: regularGrayText,

    $nest: {
      '& a': {
        color: regularGrayText
      },
      '& a:hover': {
        color: linkBlueText
      }
    }
  },
  underlinedItem: {
    $nest: {
      '& a': {
        textDecoration: 'underline'
      },
      '& a:hover': {
        color: regularGrayText
      }
    }
  },
  itemWithIcon: { paddingLeft: 22 },
  icon: { position: 'absolute', left: 0, marginTop: 3 }
});
